module.exports = {
  colors: {
    /* Shark (Black) */
    shark: "#1b1e24",
    sharkAlt: "#272a2f",
    sharkLight: "#434851",
    sharkLighter: "#8d9198",
    sharkLightest: "#b6b9be",
    /* Mako (Dark Gray) */
    mako: "#444854",
    makoLight: "#6b6f7a",
    makoLighter: "#98999d",
    makoLightest: "#d1d1d1",
    /* PaleSky (Gray) */
    palesky: "#6d7881",
    paleskyLight: "#91999f",
    paleskyLighter: "#c7c8ca",
    paleskyLightest: "#e3e3e3",
    /* Tango (Orange) */
    tangoDarkest: "#be6216",
    tangoDark: "#e17319",
    tango: "#f27e20",
    tangoLight: "#faa970",
    tangoLightest: "#f9e4d5",
    /* Solera (purple) */
    soleraDarkest: "#174384",
    soleraDark: "#184891",
    solera: "#194fa1",
    soleraLight: "#194fb1",
    soleraLightest: "#194fc1",
    /* Keppel (Teal) */
    keppelDarkest: "#1f5c5a",
    keppelDark: "#388683",
    keppel: "#36aba6",
    keppelLight: "#a4cfcd",
    keppelLightest: "#eoecec",
    /* Grassland (Green) */
    grasslandDarkest: "#325940",
    grasslandDark: "#28a353",
    grassland: "#1dbd55",
    grasslandLight: "#bbe5b3",
    grasslandLightest: "#e3f1df",
    /* Saffron (Gold) */
    saffronDarkest: "#a16e05",
    saffronDark: "#c89414",
    saffron: "#f7b617",
    saffronLight: "#ffdd8a",
    saffonLightest: "#faeed5",
    /* Monza (Red) */
    monzaDarkest: "#5c1019",
    monzaDark: "#a5091c",
    monza: "#d0021b",
    monzaLight: "#e3a2aa",
    monzaLightest: "#ffe0e4",
    /* BlueSky */
    blueskyDarkest: "#06197f",
    blueskyDark: "#0925ba",
    bluesky: "#0d31f5",
    blueskyLight: "#b6c1fc",
    blueskyLightest: "#e1e5fd",
    /* Indigo */
    indigoDarkest: "#282c45",
    indigoDark: "#2b3463",
    indigo: "#2b387f",
    indigoLight: "#9ba2ca",
    indigoLightest: "#e5e7f2",
    /* PurpleRain */
    purplerainDarkest: "#361532",
    purplerainDark: "#5c1a54",
    purplerain: "#992a8c",
    purplerainLight: "#d0b2cd",
    purplerainLightest: "#f3e9f2",
    /* Whites and off whites */
    iron: "#cccece",
    silver: "#ebebeb",
    silverAlt: "#ededed",
    white: "#fff",
    blacksqeeze: "#f5fbfa",
    alabaster: "#f7f7f7",
    athensGray: "#e4e5e8",
    alto: "#d8d8d8",
    /* Miscellaneous */
    headerColumnBorder: "#62656f",
    actionHeaderBackground: "#525662",
    zebraStripe: "#f9f9f9",
    footerFeeColor: "#035f82",
    vividBlue: "#0b8eff",
    softCyan: "#50e3c2",
    smoke: "#f9f9f9"
  }
};
